import {MatCardModule} from '@angular/material/card';
import {Component} from '@angular/core';

@Component({
    templateUrl: './wintertraining-page.component.html',
    styleUrls: ['./wintertraining-page.component.scss'],
    imports: [MatCardModule]
})
export class WintertrainingPageComponent {}
